import { useRef, useState } from "react";
import "./contact.css";
import emailjs from "@emailjs/browser";
import {
  ErrorEmailToastDark,
  ErrorEmailToastLight,
  SendEmailToastDark,
  SendEmailToastLight,
} from "../../utils/customToastify";
import {
  trackLeadGeneration,
  trackDirectContact,
} from "../../utils/analytics";

const Contact = ({ darkMode }) => {
  const initialState = {
    user_name: "",
    user_subject: "",
    user_email: "",
    user_message: "",
  };
  const formRef = useRef();
  const [form, setForm] = useState(initialState);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    if (!serviceId || !templateId || !publicKey) {
      const errorMsg = "Failed to send message. Please try again later.";
      if (darkMode) {
        ErrorEmailToastDark(errorMsg);
      } else {
        ErrorEmailToastLight(errorMsg);
      }
      trackLeadGeneration({
        status: "error",
        subject: form.user_subject,
        errorReason: "missing_config",
      });
      setLoading(false);
      return;
    }

    emailjs
      .sendForm(serviceId, templateId, formRef.current, publicKey)
      .then(
        (result) => {
          const successMsg = "Message sent successfully!";
          if (darkMode) {
            SendEmailToastDark(successMsg);
          } else {
            SendEmailToastLight(successMsg);
          }
          trackLeadGeneration({
            status: "success",
            subject: form.user_subject,
          });
          setForm(initialState);
          setLoading(false);
        },
        (error) => {
          console.error("EmailJS Error:", error);
          const userFriendlyErrorMsg =
            "Failed to send message. Please try again later.";
          if (darkMode) {
            ErrorEmailToastDark(userFriendlyErrorMsg);
          } else {
            ErrorEmailToastLight(userFriendlyErrorMsg);
          }
          trackLeadGeneration({
            status: "error",
            subject: form.user_subject,
            errorReason: error?.text || "send_failed",
          });
          setLoading(false);
        }
      );
  };

  return (
    <div className="contact-section">
      <div className="contact-container">
        
        <div className="contact-left">
          <h2 className="section-title contact-title">Let's Discuss Your Project</h2>
          <p className="contact-intro">
            Whether you are looking to hire a frontend specialist for your team, have an interesting enterprise application, 
            or want to consult on an architectural build—let's connect.
          </p>

          <div className="contact-details">
            <div className="contact-detail-card glass-panel">
              <div className="contact-detail-icon">
                <i className="fa-solid fa-envelope"></i>
              </div>
              <div className="contact-detail-info">
                <span>Email Me</span>
                <a
                  href="mailto:sezgin.akgull@gmail.com"
                  onClick={() =>
                    trackDirectContact("email", "sezgin.akgull@gmail.com")
                  }
                >
                  sezgin.akgull@gmail.com
                </a>
              </div>
            </div>

            <div className="contact-detail-card glass-panel">
              <div className="contact-detail-icon">
                <i className="fa-solid fa-phone"></i>
              </div>
              <div className="contact-detail-info">
                <span>Call / Message</span>
                <a
                  href="tel:+905346158014"
                  onClick={() =>
                    trackDirectContact("phone", "+905346158014")
                  }
                >
                  +90 534 615 80 14
                </a>
              </div>
            </div>

            <div className="contact-detail-card glass-panel">
              <div className="contact-detail-icon">
                <i className="fa-solid fa-location-dot"></i>
              </div>
              <div className="contact-detail-info">
                <span>Location</span>
                <p>Istanbul, Turkey</p>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-right">
          <div className="contact-form-wrapper glass-panel">
            <h3 className="form-title">Send a Message</h3>
            <form ref={formRef} onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Name"
                  name="user_name"
                  value={form.user_name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="text"
                  placeholder="Subject"
                  name="user_subject"
                  value={form.user_subject}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  placeholder="Email Address"
                  name="user_email"
                  value={form.user_email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <textarea
                  rows="5"
                  placeholder="Tell me about your project..."
                  name="user_message"
                  value={form.user_message}
                  onChange={handleChange}
                  required
                />
              </div>

              <button type="submit" className="btn-primary form-submit-btn" disabled={loading}>
                {loading ? "Sending..." : "Submit Message"} 
                {!loading && <i className="fa-solid fa-paper-plane"></i>}
              </button>
            </form>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Contact;
